export const sessionKeyLocation = 'bravo.token';

export const preferredBandLocation = 'bravo.preferredband'

export const DEBUG = true;

export const billboardMessageLifetime = 3500; // time in milliseconds that a billboard message lives

export const uploadTemplate = 'https://drive.google.com/uc?export=download&id=1D_lb9Z_J26BB-Bz7MMn5XIeZ94mBwBH1';

export const urls = Object.freeze({
    hostname:'/',
    apiroot:'/api/',
    authroot: '/api/auth/',
    login: '/api/auth/token/login/',
    logout: '/api/auth/token/logout/',
    users: '/api/auth/users/',
    currentUser: '/api/auth/users/me/',
    bravo: {
        bands: '/api/bravo/bands/',
        setlists: '/api/bravo/setlists/',
        songs: '/api/bravo/songs/',
        shows: '/api/bravo/shows/',
        liveShows: '/api/bravo/shows/live/',
        requests: '/api/bravo/requests/',
        plays: '/api/bravo/plays/',
    },
    ui: {
        login: '/login'
    }
});